import React from 'react'

/**
 * A business (non-residential) customer tried to sign in. Maps to the backend's
 * `code: 'business_account_blocked'` (FEDEV-565).
 *
 * Its own screen, and it names the reason outright: the account type is decided
 * server-side from the CRM contact, so this is a plain fact about their account
 * rather than a guess, and a clear message with a way to get help beats a
 * generic "those details don't match" error that would send them round in
 * circles.
 */
interface Props {
  onBack: () => void
}

function LoginBusinessBlockedStep({ onBack }: Props): React.JSX.Element {
  return (
    <div className="login-step login-step--neutral">
      <h1 className="login-step-heading">Oops! This is a business account</h1>

      <p className="login-step-subheading">
        It looks like you've tried to sign in with a business account. Our
        Customer Portal is currently only available for residential customers.
      </p>

      <p className="login-step-subheading">
        If you need help with your account, please email us on{' '}
        <a href="mailto:milk@mcqueensdairies.co.uk">milk@mcqueensdairies.co.uk</a>{' '}
        and someone from the team will be in touch.
      </p>

      <button type="button" className="btn btn-primary btn-lg btn-block" onClick={onBack}>
        Back to sign in
      </button>
    </div>
  )
}

export default LoginBusinessBlockedStep
